import { render, staticRenderFns } from "./MeasureUnitsSettingsView.vue?vue&type=template&id=0c8a4a01&scoped=true"
import script from "./MeasureUnitsSettingsView.ts?vue&type=script&lang=ts&external"
export * from "./MeasureUnitsSettingsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a4a01",
  null
  
)

export default component.exports